<template>
  <md-card class="md-card-product" :class="{
      'md-card-plain': cardPlain
    }">
    <md-card-header
      class="md-card-header-image"
      :shadow-normal="shadowNormal"
      :shadow-off="shadowOff"
      :no-colored-shadow="noColoredShadow"
    >
      <div style="position: absolute">
        <md-button class="md-just-icon md-rose" v-if="popular">
          <md-icon>favorite</md-icon>
          <md-tooltip md-direction="right">Most popular</md-tooltip>
        </md-button>
        <md-button class="md-just-icon md-default" v-if="discount">
          <img :src="discimage" />
          <md-tooltip md-direction="right">discount</md-tooltip>
        </md-button>
        <md-button class="md-just-icon md-default" v-if="!visible">
          <md-icon>visibility_off</md-icon>
          <md-tooltip md-direction="right">invisible</md-tooltip>
        </md-button>
      </div>
      
      <a
        @click="onClick"
        :href=" link ? link : 'javascript:void(0)'"
        style="text-align: center"
        :target="link ? '_blank' : '_self'"
      >
        <img style="width: 100%; height: 250px" :src="cardImage" />
      </a>

      <div
        v-if="!noColoredShadow && !shadowNormal && !shadowOff"
        class="colored-shadow"
        :style="shadowImageBlog(cardImage)"
      />
    </md-card-header>

    <md-card-content v-if="$slots.cardContent" :class="{ 'text-center': textCenter }">
      <a
        :href=" link ? link : 'javascript:void(0)'"
        style="text-align: center"
        :target="link ? '_blank' : '_self'"
      >
        <slot name="cardContent" />
      </a>
    </md-card-content>

    <md-card-actions v-if="$slots.cardAction">
      <slot name="cardAction" />
    </md-card-actions>
  </md-card>
</template>

<script>
import { discount } from '../../services/helper'
export default {
  name: "ProductCard",
  data() {
    return {
      discimage: discount
    }
  },
  props: {
    type: String,
    textCenter: Boolean,
    reverseRow: Boolean,
    cardImage: String,
    shadowNormal: Boolean,
    shadowOff: Boolean,
    cardPlain: Boolean,
    noColoredShadow: Boolean,
    link: String,
    id: String,
    popular: Boolean,
    visible: Boolean,
    discount: Boolean
  },
  methods: {
    shadowImageBlog(image) {
      return {
        backgroundImage: `url(${image})`,
        opacity: 1
      };
    },
    onClick() {
      if (!this.link) this.$emit("clicked", this.id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
